
@if (allowColumnCollapse()) {
  <div class="visual-editor-collapsed-tabs user-select-none">
    <div [class.visible]="datasetColumnCollapsed()"
         (click)="setDatasetColumnCollapsed(false)">
      <span>Dataset</span>
    </div>
    <div [class.visible]="layoutColumnCollapsed()"
         [class.second]="datasetColumnCollapsed()"
         (click)="setLayoutColumnCollapsed(false)">
      <span>Layout</span>
    </div>
  </div>
}

<div class="visual-editor-dataset-column" [class.collapsed]="datasetColumnCollapsed()">
  <div class="visual-editor-top mx-5">
    <div class="visual-editor-dataset-dropdown" [class.allow-column-collapse]="allowColumnCollapse()">
      <span class="user-select-none">
        <span class="c-red p-relative not-1">*</span>
        <strong>Dataset:</strong>
      </span>
      <div class="d-flex flex-grow justify-content-between overflow-hidden ml-10">
        <mat-select #datasetSelect
                    class="trg-outline h-30 fs-12 visual-editor-dropdown user-select-none"
                    panelClass="trg-outline-dropdown visual-editor-dropdown-panel visual-editor-dropdown-panel-dataset"
                    [disabled]="busy()"
                    placeholder="Select Dataset"
                    [value]="dataset()"
                    (valueChange)="onDatasetChange($event, datasetSelect)"
                    style="flex: 1">
          @let iconMaxWidth = datasetIconMaxWidth();

          @let sd = dataset();
          <mat-select-trigger [title]="sd?.longTitle()">
            @if (sd) {
              <div class="visual-editor-schema-option-left">
                <visual-editor-schema-option-dataset [title]="sd.listTitle()"
                                                     [icon]="sd.icon()"
                                                     [iconWidth]="sd.icon()?.widthRatio ?? 1">
                </visual-editor-schema-option-dataset>
              </div>
              <div class="visual-editor-schema-option-right">
              </div>
            }
          </mat-select-trigger>

          @let pds = productDatasets();
          @if (pds?.length) {
            <mat-optgroup label="Core Datasets">
              @for (d of pds; track d.id) {
              <mat-option [title]="d.longTitle()" [value]="d">
                <div class="visual-editor-schema-option-left">
                  <visual-editor-schema-option-dataset [title]="d.listTitle()"
                                                       [icon]="d.icon()"
                                                       [iconWidth]="iconMaxWidth">
                  </visual-editor-schema-option-dataset>
                </div>
                <div class="visual-editor-schema-option-right">
                </div>
              </mat-option>
              }
            </mat-optgroup>
          }

          @let uds = userDatasets();

          <mat-optgroup label="Extended Dataset">
            @for (d of uds; track d.id) {
              <mat-option [title]="d.longTitle()" [value]="d">
                <div class="visual-editor-schema-option-left">
                  <visual-editor-schema-option-dataset [title]="d.listTitle()"
                                                       [icon]="d.icon()"
                                                       [iconWidth]="iconMaxWidth"
                                                       [buttons]="true"
                                                       (edit)="editExtendedDatasetClick(d)"
                                                       (remove)="removeExtendedDatasetClick(d)">
                  </visual-editor-schema-option-dataset>
                </div>
                <div class="visual-editor-schema-option-right">
                </div>
              </mat-option>
            }

            <mat-option (click)="addExtendedDatasetClick($event)" [hidden]="uds.length">
              <div class="visual-editor-schema-option-left ml-15">
                <span class="visual-editor-schema-option-link-btn">Add Extended Dataset</span>
              </div>
            </mat-option>
          </mat-optgroup>
        </mat-select>

        @if (allowColumnCollapse()) {
          <button trgButton color="white"
                  class="h-30 px-0 ml-4"
                  [disabled]="busy()"
                  (click)="setDatasetColumnCollapsed(true)"
                  style="flex: 0 0 20px">
            <i class="fas fa-chevron-double-left i-12 p-relative ot-1"></i>
          </button>
        }
      </div>
    </div>
  </div>

  @for (d of allDatasets(); track d.id) {
    @if (d.opened()) {
      <visual-editor-field-list [hidden]="d != dataset()"
                                [busy]="busy()"
                                [dataset]="d"
                                [(hideUnmatched)]="hideUnmatchedFields">
      </visual-editor-field-list>
    }
  }
</div>

<div class="visual-editor-layout-section-column"
     [class.has-style-editor]="!!styleEditor()"
     [class.collapsed]="layoutColumnCollapsed()"
     [class.style-editor-visible]="styleEditor() && mode() == Mode.Style">
  <div class="visual-editor-top mx-5">
    <div class="visual-editor-layout-section-header">
      <div>
        <span class="user-select-none">
          <span class="c-red p-relative not-1">*</span>
          <strong>Layout:</strong>
        </span>
      </div>

      <mat-select 
            class="trg-outline h-30 fs-12 visual-editor-layout user-select-none ml-10"
            panelClass="trg-outline-dropdown visual-editor-dropdown-panel"
            [disabled]="busy()"
            [value]="mode()"
            (valueChange)="mode.set($event)"
            style="flex: 1"
            data-test-id="visual-editor-layout-dropdown">
        <mat-select-trigger>
          <div class="d-flex align-items-center">
            <i class="fas {{mode() == Mode.Fields ? 'fa-list' : 'fa-paint-brush'}} i-12 w-18"></i>
            <span>{{mode() == Mode.Fields ? 'Fields' : 'Customizations'}}</span>
          </div>
        </mat-select-trigger>
        <mat-option [value]="Mode.Fields" title="Fields" data-test-id="visual-editor-layout-dropdown__fields">
          <div class="d-flex align-items-center">
            <i class="fas fa-list i-12 w-18"></i>
            <span>Fields</span>
          </div>
        </mat-option>
        <mat-option [value]="Mode.Style" title="Customizations" data-test-id="visual-editor-layout-dropdown__customizations">
          <div class="d-flex align-items-center">
            <i class="fas fa-paint-brush i-12 w-18"></i>
            <span>Customizations</span>
          </div>
        </mat-option>
      </mat-select>

      <!--
      <div [hidden]="!styleEditor()"
           class="layout-toggle"
           [class.layout-toggle-fields]="mode() == Mode.Fields"
           [class.layout-toggle-style]="mode() == Mode.Style"
           (click)="toggleMode()">
        <div class="dot"></div>
        <div class="left">
          <i class="fas fa-list"></i>
        </div>
        <div class="right">
          <i class="fas fa-paint-brush"></i>
        </div>
      </div>
      -->

      <div>
      @if (allowColumnCollapse()) {
        <button trgButton color="white"
                class="w-20 h-30 px-0 ml-4"
                [disabled]="busy()"
                (click)="setLayoutColumnCollapsed(true)">
          <i class="fas fa-chevron-double-left i-12 p-relative ot-1"></i>
        </button>
      }
      </div>
    </div>
  </div>

  <div class="layout-section-bottom-wrapper">
    <div class="role-item-groups">
      @for (r of fieldRoles(); track r.id) {
        <visual-editor-role-item-group [hidden]="r.isHidden()"
                                       [busy]="busy()"
                                       [visual]="visual()"
                                       [role]="r"
                                       (setExpansionState)="setRoleExpansionState(r, $event)">
        </visual-editor-role-item-group>
      }
      @if (hasInvalidCustomField()){
        <div class="error-section d-flex c-red fs-12">
          <span class="fas fa-exclamation-triangle fs-11"></span>
          <div class="d-flex pl-5">Calculated Fields with errors won’t be included in the Visual.</div>
        </div>
      }
    </div>
    @if (styleEditor()) {
      <div class="style-editor">
        <ng-container #styleEditorContainer></ng-container>
      </div>
    }
  </div>
</div>
